import React from "react";
import LifeAndHobbies from "../LifeSection";

const Blogs = () => {
  return (
    <div className="page blogs-page">
      <LifeAndHobbies />
    </div>
  );
};

export default Blogs;
